
import { combineReducers } from 'redux';
import { locations } from "./locations/reducer";
import { devices } from './devices/reducer'
import { ActivityInterface } from './types';

const reducers = combineReducers<ActivityInterface>({ locations, devices })

export { reducers as activity }
export default reducers;
